import { render, staticRenderFns } from "./custom-events.vue?vue&type=template&id=24ccb9bb"
import script from "./custom-events.vue?vue&type=script&lang=js"
export * from "./custom-events.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports